module.exports = __webpack_public_path__ + "img/productsList.96496c8d.svg";